import { YES_VALUE } from 'constants/constants';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { IMPORTED_COMPANION_ASSESSMENT_TYPE } from 'pages/AssessmentDetails/constants';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export function useAssessmentDetail() {
  const parentAssessmentDetail = useSelector((state: any) => get(state, 'assessmentsOverview.assessmentDetails[0]', {}));
  const assessmentDynamicDetails = useSelector((state: any) => get(state, 'assessmentsOverview.assessmentDynamicDetails[0]', null));

  const isValidatedAsm = parentAssessmentDetail.IsValidatedAssessment === YES_VALUE;
  const isCompanionAsm = parentAssessmentDetail.AssessmentTypeId === IMPORTED_COMPANION_ASSESSMENT_TYPE;
  const answerBySecCert = parentAssessmentDetail.AnswerBySecCert === YES_VALUE;

  const showUnvalidatedLabel = !isValidatedAsm && !isCompanionAsm && !answerBySecCert;

  const clientName = !isEmpty(parentAssessmentDetail) ? parentAssessmentDetail?.ClientOrgName || '' : assessmentDynamicDetails?.ClientName || '';

  const retObj = useMemo(
    () => ({ isValidatedAsm, isCompanionAsm, answerBySecCert, showUnvalidatedLabel, clientName }),
    [isValidatedAsm, isCompanionAsm, answerBySecCert, showUnvalidatedLabel, clientName]
  );

  return retObj;
}
